import React, { FC } from 'react';

import { Box, Loader, useMantineTheme } from '@mantine/core';

import { Z_INDEX } from '@diagram/diagram-dimensions';
import { useCanvas } from '@diagram/hooks/use-canvas';

import background from './DiagramGridBackground.svg';

const DiagramGridBackground: FC<{
    loading?: boolean;
}> = ({ loading = false }) => {
    const theme = useMantineTheme();
    const { grid: showGrid } = useCanvas();

    return showGrid ? (
        <Box
            style={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,

                zIndex: Z_INDEX.CANVAS.GRID,

                backgroundImage: `url(${background.src})`,
                backgroundRepeat: 'repeat',

                // Frame the grid on all sides, so its edges don't depend on the coordinate strips around it
                outline: `1px solid ${theme.colors.gray[1]}`,
                outlineOffset: -1,

                pointerEvents: 'none',
            }}
            data-diagram-background
        >
            {loading && (
                <Loader
                    pos="fixed"
                    left="50%"
                    top="50%"
                    size="lg"
                    color="blue"
                    style={{ transform: 'translate(-50%, -50%)' }}
                />
            )}
        </Box>
    ) : null;
};

export { DiagramGridBackground };
